module.exports = __webpack_public_path__ + "img/bike.efa99626.svg";